import { render, staticRenderFns } from "./TemplateWidget.vue?vue&type=template&id=2401af05"
import script from "./TemplateWidget.vue?vue&type=script&lang=js"
export * from "./TemplateWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports